import i18next, { t } from 'i18next';
import React from 'react';
import PropTypes from 'prop-types';
import ReactApexChart from 'react-apexcharts';
import { Card, Col, Row } from 'react-bootstrap';
import NoDataLayer from '../../../../../Common/NoDataLayer';

class ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: !this.props.inputParam_UseFake ? this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items.length > 0 ? [
                this.props.inputParam_ComponentContent.items[0].montoBase,
                this.props.inputParam_ComponentContent.items[0].montoReajuste,
                this.props.inputParam_ComponentContent.items[0].montoID,
                this.props.inputParam_ComponentContent.items[0].montoSaldo] : [] : [25, 25, 25, 25],
      options: {
        chart: {
          type: 'pie',
          height:"100%", width:"100%"
        },
        labels: [t('data-lang-lbl-serviceexpense'), t('data-lang-lbl-adjustmentexpense'), t('data-lang-lbl-diexpense'), t('data-lang-lbl-balance')], // Nombres de las tres series
        colors: ["#406A9C","#ABBAD7", "#d39128", "#84B681D9"], // Colores para cada serie
        legend: {
          position: 'bottom'
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return parseFloat(value.toFixed(2)).toLocaleString(i18next.language);
            }
          },
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
      montos: [
        {
          text: t('data-lang-lbl-serviceexpense'),
          value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null && this.props.inputParam_ComponentContent.items.length > 0 ?
            this.props.inputParam_ComponentContent.items[0].montoBase : '--') : '--'
        },
        {
          text: t('data-lang-lbl-adjustmentexpense'),
          value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null && this.props.inputParam_ComponentContent.items.length > 0 ?
            this.props.inputParam_ComponentContent.items[0].montoReajuste : '--') : '--'
        },
        {
          text: t('data-lang-lbl-diexpense'),
          value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null && this.props.inputParam_ComponentContent.items.length > 0 ?
            this.props.inputParam_ComponentContent.items[0].montoID : '--') : '--'
        },
        {
          text: t('data-lang-lbl-balance'),
          value: !this.props.inputParam_UseFake ? (this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.items !== null && this.props.inputParam_ComponentContent.items.length > 0 ?
            this.props.inputParam_ComponentContent.items[0].montoSaldo : '--') : '--'
        }
      ]
    };
  }

  static propTypes = {
    inputParam_HideHeader: PropTypes.bool,
    inputParam_UseFake: PropTypes.bool,
  };

  static defaultProps = {
    inputParam_HideHeader: false,
    inputParam_UseFake: false,
  };

  renderContent() {
    return  <Row className='px-3 h-100' style={{opacity: this.props.inputParam_UseFake ? ".4" : ""}}>
              <Col xl={6} className='p-0 m-auto h-100'>
                {
                  this.state.series.length > 0 ?
                  <ReactApexChart options={this.state.options} series={this.state.series} type="pie" height="100%" width="100%" /> :
                  <NoDataLayer display={true} />
                }
              </Col>
              <Col xl={6} className='p-0 my-0 m-auto h-90'>
                {
                  this.state.montos.map((item, index) => (
                    <div key={index} className='m-1 p-1 h-25' style={{backgroundColor: "#EFEFEF"}}>
                      <div className='text-end font-weight-bold' style={{ fontSize: "24px" }}>{!isNaN(item.value) ? parseFloat(parseFloat(item.value).toFixed(2)).toLocaleString() : '--'}</div>
                      <div className='text-start' style={{ fontSize: "16px" }}>{item.text}</div>
                    </div>
                  ))
                }
              </Col>
            </Row>
  }

  render() {
    return (
      <>
        {
          !this.props.inputParam_UseFake &&
          <Card className='h-100'>
            {
              !this.props.inputParam_HideHeader &&
              <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                  <b>{ this.props.inputParam_ComponentContent !== null && this.props.inputParam_ComponentContent.boardComponentTitle !== null ? this.props.inputParam_ComponentContent.boardComponentTitle : t('data-lang-boxname-expenditurebalancedistribution')}</b>
                  <div className='toolbar d-flex'>
                  </div>
                </Card.Title>
              </Card.Header>
            }
            <Card.Body className='px-1 py-0 h-100'>
              {this.renderContent()}
            </Card.Body>
          </Card>
        }
        {this.props.inputParam_UseFake && this.renderContent()}
      </>
    );
  }
}

export default ELEMENT_CONTRACT_EXPENSE_BALANCE_DETAIL;